import * as React from 'react';

const PhoneChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4 16.9s.2-.2.2-.3c.5-.6 1.4-1.7 1.4-1.7l5 1.2v3.1c0 .5-.4.9-.9.9C10.8 20 4 13.2 4 4.9c0-.5.4-.9.9-.9H8l1.2 5s-.9 1.1-1.4 1.7l-.3.3c1.3 2.5 3.3 4.6 5.9 5.9z"
        />
    </svg>
);

PhoneChunkySvg.displayName = 'PhoneChunkySvg';
export default PhoneChunkySvg;
